export default __webpack_public_path__ + "static/media/umi_mlgu2.a5482b81.png";